import { getServices } from '~/db/services';

export const useActionPlayTutorial = () => {
  const profile = useProfileStore();

  const { onPlay, complete } = useAbstractAction(
    'actionCheckPlayTutorial',
    false
  );

  const hasPlayedTutorial = useNomadStorage('hasPlayedTutorial', false);

  const { onComplete: onCompleteTutorial, start } = useDialogTutorial();

  const { $db } = useNuxtApp();

  const { progressionsService } = getServices($db);

  const completeAction = () => {
    hasPlayedTutorial.value = true;
    complete(true);
  };

  onCompleteTutorial(() => {
    completeAction();
  });

  const checkIfhasProgressions = async () => {
    const count = await progressionsService.count();
    return count > 0;
  };

  onPlay(async () => {
    if (profile.isParent || profile.isASubscriber || hasPlayedTutorial.value) {
      // if parent no tuto
      return completeAction();
    }

    const hasProgressions = await checkIfhasProgressions();
    if (hasProgressions) {
      return completeAction();
    }

    start();
  });
};
